import React from 'react';
import styled from 'styled-components';
import Header from './Header';
import Footer from './Footer';

const LayoutWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--paper);
  color: var(--text-hi);
`;

const Main = styled.main`
  flex: 1;
  padding-top: 80px;
`;

const PageLayout = ({ children }) => {
  return (
    <LayoutWrapper>
      <Header />
      <Main>
        {children}
      </Main>
      <Footer />
    </LayoutWrapper>
  );
};

export default PageLayout;
